/**
 * Whether an HTTP refusal is about what the visitor sent or did, so that a
 * form shows it in the calm "encourage" look rather than the red one
 * (CLAUDE.md's student UX rule: a visitor's own situation is never red). A
 * wrong password (401), a username or email that exists (409), a password that
 * misses a rule (400), a code that doesn't match (403), a value the server
 * can't take (422), too many tries in a minute (429).
 *
 * Red stays for the system's own failures: a 5xx, no answer at all, and any
 * status these forms don't expect (a 404 from a misrouted API, say).
 *
 * Login, ResetPassword and VerifyEmail all use it, so the three can't drift
 * apart.
 */
const VISITORS_OWN = new Set([400, 401, 403, 409, 422, 429]);

export default function isVisitorsOwnRefusal(status) {
  return VISITORS_OWN.has(status);
}

/**
 * What a form says for such a refusal when its body carries no message to
 * show (an edge proxy's 403 page, a 429 from outside the API): calm words to
 * go with the calm look, never "Connection error" or "Something went wrong".
 */
export function visitorRefusalFallback(status) {
  return status === 429
    ? 'Too many tries just now. Please wait a minute, then try again.'
    : "That wasn't accepted. Please check what you entered and try again.";
}
